"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractWidget_1 = __importDefault(require("./AbstractWidget"));
var IFrameWidget = /** @class */ (function (_super) {
    __extends(IFrameWidget, _super);
    function IFrameWidget(config, iframe) {
        var _this = _super.call(this, config) || this;
        _this._iframe = iframe;
        _this.addNotificationListeners();
        _this.render();
        return _this;
    }
    /**
     * IIFrameWidget required method. Returns the iframe of this widget
     */
    IFrameWidget.prototype.getIframe = function () {
        return this._iframe;
    };
    /**
     * Render content
     */
    IFrameWidget.prototype.render = function () {
        if (this.getConfig().target && !this.isRendered())
            this.getConfig().target.appendChild(this._iframe);
    };
    /**
     * Check is target container already has a inframe widget
     * @returns
     */
    IFrameWidget.prototype.isRendered = function () {
        return this.getConfig().target.getElementsByClassName("bp-frame").length > 0;
    };
    /**
     * IFrame loaded
     * @param e
     */
    IFrameWidget.prototype.onIFrameLoaded = function (e) { };
    /**
     * Registra los listeners para notificar cambios al iframe padre
     */
    IFrameWidget.prototype.addNotificationListeners = function () { };
    return IFrameWidget;
}(AbstractWidget_1.default));
exports.default = IFrameWidget;
